import axios from 'axios'
import {getApiUrl} from '../api-config'
import {permissionResponseInterceptor} from './interceptors/permission-response'
import {unauthorizedResponseInterceptor} from './interceptors/unauthorized-response'

export const apiClient = axios.create({withCredentials: true})
apiClient.interceptors.response.use(undefined, permissionResponseInterceptor)
apiClient.interceptors.response.use(undefined, unauthorizedResponseInterceptor)
export const http = {
    get: async (url, params) => apiClient.get(getApiUrl(url), params),
    post: async (url, params, headers) => apiClient.post(getApiUrl(url), params, headers),
    head: async (url, params) => apiClient.head(getApiUrl(url), params),
    delete: async (url, params) => apiClient.delete(getApiUrl(url), params),
    put: async (url, params, headers) => apiClient.put(getApiUrl(url), params, headers),
    patch: async (url, params, headers) => apiClient.patch(getApiUrl(url), params, headers),
    fetch: async (url, params) => fetch(getApiUrl(url), {credentials: 'include', ...params}),
};
